var _path, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGundj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 90,
    viewBox: "0 0 180 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H172C176.418 0 180 3.58172 180 8V82C180 86.4183 176.418 90 172 90H8C3.58172 90 0 86.4183 0 82V8Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2119_958",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 179,
    height: 88
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 179,
    height: 88,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2119_958)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2119_958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.0667 38.0114H114.711H91.0667ZM102.912 26.3901V49.747V26.3901Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0667 38.0114H114.711M102.912 26.3901V49.747",
    stroke: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1335 45.8934C78.2957 46.5964 79.5606 46.5538 79.5606 48.6297V62.0888C79.5606 64.9724 79.8372 72.2093 68.5326 72.5172C52.9216 72.9433 54.311 48.0894 54.311 48.0894C54.311 48.0894 54.1529 20.3211 68.6512 20.2435C81.8333 20.1855 88.375 37.8857 88.375 42.5528V20.4179C88.375 20.4179 84.62 28.2223 83.3156 28.2223C82.5448 28.2223 77.8214 20.263 68.6512 20.263C59.4949 20.263 45.0222 29.4229 45.0222 48.0894C45.0222 66.8489 58.3012 72.2926 68.3745 72.5172C77.683 72.7244 79.7582 65.4643 84.4026 65.4643C88.8493 65.4643 89.205 72.6547 89.205 73.104V48.6297C89.205 48.6297 89.205 48.6336 89.205 48.6414C89.205 46.5809 90.6082 46.577 98.5333 45.8934H70.1335Z",
    fill: "#455A64",
    stroke: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.055 19.0142L105.025 19.883H105.055L112.693 20.3549H112.704H112.716C114.875 20.3737 115.728 21.1091 116.135 21.8005C116.542 22.4919 116.476 23.1712 116.476 23.1712L116.472 23.1936V23.2161L116.495 63.6402C116.495 63.6402 116.462 65.8251 115.578 67.992C115.136 69.0754 114.486 70.1422 113.542 70.9281C112.614 71.7008 111.399 72.2105 109.744 72.2276C109.712 72.2278 109.678 72.2314 109.646 72.2314C109.52 72.2314 109.385 72.2159 109.255 72.2089C109.094 72.2016 108.935 72.1946 108.778 72.179C108.207 72.1142 107.602 71.9903 106.981 71.8045C106.764 71.7395 106.541 71.6592 106.321 71.5798C104.712 70.9188 103.399 69.8252 102.406 68.6062C101.6 67.6169 101.011 66.5478 100.666 65.5877C100.436 64.9481 100.33 64.3646 100.314 63.8912C101.008 64.4515 102.229 65.1645 104.275 65.1645C106.079 65.1645 107.625 64.5637 108.709 63.4942C109.794 62.4247 110.404 60.8972 110.404 59.1125C110.404 55.5193 107.644 53.0043 104.237 53.0043C102.472 53.0043 100.723 53.532 99.419 54.7907C98.1149 56.0494 97.2888 58.0183 97.2888 60.7753V61.749L97.3646 61.6816C97.6376 65.2006 99.4143 67.9898 101.697 69.9095C103.289 71.2478 105.11 72.1761 106.852 72.6733C107.123 72.7559 107.402 72.8237 107.686 72.883C107.723 72.8907 107.759 72.8982 107.796 72.9055C108.075 72.9604 108.357 73.0062 108.649 73.0366C108.891 73.064 109.125 73.0773 109.358 73.0853C109.461 73.0885 109.559 73.104 109.665 73.104C109.693 73.104 109.716 73.0968 109.744 73.0965C113.297 73.0834 117.415 72.3529 120.706 70.4637C124.027 68.5573 126.494 65.4111 126.494 60.7678V23.2348V23.2161V23.1974C126.494 23.1974 126.439 22.5359 126.854 21.8567C127.27 21.1774 128.133 20.4523 130.273 20.4335H130.288H130.303L137.066 19.883H137.073L137.111 19.8793L137.073 19.0142H137.039H105.082H105.055Z",
    fill: "#455A64"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2119_958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93.3333,
    height: 57.7778,
    fill: "white",
    transform: "translate(43.7778 16.5555)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGundj);
export default __webpack_public_path__ + "static/media/gundj.215e0452d6e738c663a5032ebb3d48aa.svg";
export { ForwardRef as ReactComponent };